module.exports = __webpack_public_path__ + "static/median-time-mobile-1057871b761ad03a875dfb6834b609c5.png";